export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-07.jpg'),
        title: '企业应用程序',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '专业高效的企业软件，帮助企业抓住机遇',
      description: `<p style="font-size:1.05rem">业务应用程序（业务应用程序）是为商业组织和大型企业创建的解决方案和应用程序。 企业级应用程序具有许多特征，例如大量用户，大量数据，密集交易等。它们通常可以满足未来业务需求的变化，并且易于升级和维护。 各种先进高效的企业软件可以帮助企业在工业4.0时代抢占优势，节省运营管理资金，提高效率。 与常见应用程序相比，海量数据存储，大量图形用户界面和复杂的业务逻辑使企业级应用程序需要更高级的功能和更稳定的系统性能。</p>`
    },
    {
      title: '我们能提供什么',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-07.jpg')+`)"></span>
      <span>随着Internet的发展，传统的分布式计算技术暴露出许多问题，无法满足供应链环境下企业应用的需求。 基于Internet，面向服务，组件级调用和跨平台需求促使出现了新一代面向服务的分布式对象技术Web服务技术。 由于拥有专业和经验丰富的研发团队，Maesinfo致力于提供这种新的服务技术。 我们将与客户就企业应用的独特性进行密切沟通和协作，并实施持续交付的概念。 敏捷开发的想法将在整个企业应用程序的开发中实施。</span>`
    }
  ]
}
